import * as React from 'react'

interface OutlineButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode
  icon?: React.ReactNode
}

export const OutlineButton: React.FC<OutlineButtonProps> = ({
  children,
  icon,
  className = '',
  ...props
}) => (
  <button
    type="button"
    {...props}
    className={`w-full flex items-center justify-center gap-2 rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
  >
    {icon}
    {children}
  </button>
)

export default OutlineButton
